import axios from 'axios';
import { createContext, useEffect, useState } from 'react';
import api, { setApiContext } from 'services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(true);
  const modulo = 'PRODUCAO';
  const isAuthenticated = !!user;

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      refresh();
    } else {
      saveUser();
    }
  }, []);

  const saveUser = async (user) => {
    try {
      if (process.env.NODE_ENV === 'development') {
        localStorage.setItem('ESolution:refreshToken', user?.refresh_token);
        api.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${user?.access_token}`;
      }
      const { data } = await api.get('/Auth/User', { skipRetry: true });
      const perfil = data?.perfis?.find((p) => p?.modulo === modulo);
      if (Boolean(perfil)) {
        const permissoes = perfil?.permissoes ?? null;
        setUser({ ...user, ...data, permissoes });
      } else {
        throw new Error('Usuário sem permissão de acesso');
      }
    } catch (error) {
      throw error;
    } finally {
      setIsRefreshing(false);
    }
  };

  const login = async (body) => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_API_AUTH_URL + '/SignIn';
      const { data } = await axios.post(url, body);
      await saveUser(data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    try {
      setIsRefreshing(true);
      const refresh_token = localStorage.getItem('ESolution:refreshToken');
      const url = process.env.REACT_APP_API_AUTH_URL + '/Refresh';
      const options = { withCredentials: true };
      const body =
        process.env.NODE_ENV === 'development' ? { refresh_token } : {};
      const { data } = await axios.post(url, body, options);
      await saveUser(data);
    } catch (error) {
      setUser(null);
    } finally {
      setIsRefreshing(false);
    }
  };

  const logout = async () => {
    try {
      const url = process.env.REACT_APP_API_AUTH_URL + '/SignOut';
      const options = { withCredentials: true };
      await axios.post(url, null, options);
    } catch (error) {
    } finally {
      localStorage.removeItem('ESolution:refreshToken');
      api.defaults.headers.common['Authorization'] = null;
      setUser(null);
    }
  };

  setApiContext({ refresh, logout });

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
        isRefreshing,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
